module.exports = __webpack_public_path__ + "assets/img/be7d-gw.svg";